import _ from 'lodash';

export function startCaseWithSpace(text) {
    return _.startCase(text.replace(/_/g, ' ').toLowerCase());
}
